import React from "react";
import colors from "@nib-components/colors";
import { TickInCircleSystemIcon, InfoSystemIcon, WarningSystemIcon, CrossInCircleSystemIcon } from "@nib/icons";
export var pickColor = function pickColor(alertType) {
  switch (alertType) {
    case "info":
    default:
      return "#005bb9";

    case "error":
      return "#c81414";

    case "success":
      return "#007800";

    case "warning":
      return colors.kate;
  }
};
export var pickBackgroundColor = function pickBackgroundColor(alertType) {
  switch (alertType) {
    case "info":
    default:
      return "#ebf2fa";

    case "error":
      return "#fcedeb";

    case "success":
      return "#ebf6ee";

    case "warning":
      return "#fff9eb";
  }
};
export var renderIcon = function renderIcon(type, isIconColored) {
  var fill = isIconColored ? pickColor(type) : "#ffffff";

  switch (type) {
    case "info":
    default:
      return /*#__PURE__*/React.createElement(InfoSystemIcon, {
        fill: fill
      });

    case "error":
      return /*#__PURE__*/React.createElement(CrossInCircleSystemIcon, {
        fill: fill
      });

    case "success":
      return /*#__PURE__*/React.createElement(TickInCircleSystemIcon, {
        fill: fill
      });

    case "warning":
      return /*#__PURE__*/React.createElement(WarningSystemIcon, {
        fill: colors.doc
      });
  }
};